export default __webpack_public_path__ + "bbab5f15eaa7d526ffd5865e42a27629.svg";